const { createContext, useContext } = require("react");

const KanbanContext = createContext();
function KanbanProvider(props) {
	const values = { ...props };
	return (
		<KanbanContext.Provider value={values}>
			{props.children}
		</KanbanContext.Provider>
	);
}
function useKanban() {
	const context = useContext(KanbanContext);
	if (typeof context === "undefined")
		throw new Error("useKanban must be used within KanbanProvider");
	return context;
}
export { useKanban, KanbanProvider };
